import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  USER_HANDLER
} from "../../constants/ActionTypes";
import Service from "../../service";
import { clearSharedSso } from "../../utils/ssoCookie";
import { clearGlobalSearchStorageForCurrentUser } from "../../components/GlobalSearch/globalSearchStorageKey";

export const userSignUp = (user) => {
  return {
    type: SIGNUP_USER,
    payload: user
  };
};
export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    payload: user
  };
};
export const userSignOut = () => async (dispatch) => {
  try {
    // Call logout API to log the activity
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      try {
        await Service.makeAPICall({
          methodName: Service.postMethod,
          api_url: Service.logout,
        });
      } catch (error) {
        // Even if API call fails, continue with logout
        console.error("Logout API error:", error);
      }
    }
  } catch (error) {
    console.error("Error during logout:", error);
  } finally {
    // Must run before user_data/companyDomain are cleared below - it needs
    // both still in localStorage to know which user's Global Search keys to
    // remove. Wrapped internally in try/catch so a cleanup failure never
    // blocks the rest of logout.
    clearGlobalSearchStorageForCurrentUser();

    // Clear localStorage regardless of API call result
    localStorage.removeItem('user_data')
    localStorage.removeItem('is_reporting_manager')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('resourceAccess')
    localStorage.removeItem('is_assistant_reporting_manager')
    localStorage.removeItem('ssoToken')
    localStorage.removeItem('companyDomain')
    // Clearing the shared cookie logs the user out of every sibling WeekMate
    // app too (each app's visibility watcher notices the cookie is gone).
    clearSharedSso()

    dispatch({
      type: SIGNOUT_USER_SUCCESS
    });
  }
};
export const userSignUpSuccess = (authUser) => {
  return {
    type: SIGNUP_USER_SUCCESS,
    payload: authUser
  };
};

export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: authUser
  }
};
export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};


export const userData = (userDetail) => {
  return {
    type: USER_HANDLER,
    payload: userDetail
  }
}
export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};
export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};
